import { getCostumers, setCustomer } from '@/services/purchase-orders';
import { Message } from 'element-ui';
import * as types from '../mutation-types';

const state = {
  customers: [],
  newCustomer: {},
};

const getters = {
  getCustomers: state => state.customers,
  getNewCustomer: state => state.newCustomer,
};

const mutations = {
  [types.SET_CUSTOMERS](state, customersArr) {
    state.customers = customersArr;
  },
  [types.SET_CUSTOMER](state, customer) {
    state.newCustomer = customer;
  },
};

const actions = {
  setCustomer({ commit }, customerName) { //eslint-disable-line
    setCustomer(customerName)
      .then(response => response.data)
      .then((data) => {
        Message.success('New Customer created!');
        return commit(types.SET_CUSTOMER, data);
      })
      .catch((error) => {
        if (error.response.data.message) {
          Message.error(error.response.data.message);
        } else {
          Message.error('Something went wrong! Try again.');
        }
      });
  },
  setCustomers({ commit }) {
    getCostumers().then(response => response.data).then((data) => {
      commit(types.SET_CUSTOMERS, data.results);
    }).catch((error) => {
      if (error.response.data.message) {
        Message.error(error.response.data.message);
      } else {
        Message.error('Something went wrong! Try again.');
      }
    });
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/customers.js